import {Component, ElementRef, Inject, OnInit, Renderer2, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NotificationService} from '../../services/notification.service';
import Quill from 'quill';
import {SeriesDataService} from "../../services/series_data.service";
import {SeriesColumnList} from "../../_typing/series-column";
import {copyStringToClipboard} from "../../lib/utils";
import {ALLOWED_FONT_SIZES, NOTIFICATION_DURATION_MS} from "../../shared/globals";
import {QuillEditorComponent} from "ngx-quill";
import {
    SelectSearchComponentComponent
} from "../../components/select-search-api/single/select-search-component.component";
import {SharedModule} from "../../shared/modules/shared-module.module";

export interface DialogData {
    form_result: string;
    config: { paragraph_body: any };
}

@Component({
    selector: 'paragraph-form',
    templateUrl: './paragraph-form.component.html',
    imports: [
        SharedModule,
        QuillEditorComponent,
        SelectSearchComponentComponent
    ],
    styleUrls: ['./paragraph-form.component.less']
})
export class ParagraphFormComponent implements OnInit {
    @ViewChild('imageUpload', {static: true}) fileUpload: ElementRef<HTMLInputElement>;
    @ViewChild('quillEditorComponent') quillEditorComponent: any;

    showing_hints: boolean = false;
    paragraph: any = '';
    quillInstance: any;
    insert_series: any;
    insertColumn: any;
    gssInsert: any;
    allColumns: SeriesColumnList;

    editorModules = {
        toolbar: {
            container: [
                ['bold', 'italic', 'underline', 'strike'],
                ['blockquote', 'code-block'],
                [{header: 1}, {header: 2}],
                [{list: 'ordered'}, {list: 'bullet'}],
                [{script: 'sub'}, {script: 'super'}],
                [{indent: '-1'}, {indent: '+1'}],
                [{align: ''}, {align: 'center'}, {align: 'right'}, {align: 'justify'}],
                [{direction: 'rtl'}],
                [{size: [false, ...ALLOWED_FONT_SIZES]}],
                [{header: [1, 2, 3, 4, 5, 6, false]}],
                [{color: []}, {background: []}],
                [{"font": ['Rajdhani', 'sans-serif', 'serif', 'monospace']}],
                ['link', 'image'],
                ['clean']
            ],
            handlers: {
                image: () => this.selectLocalImage()
            }
        }
    };

    constructor(
        private http: HttpClient,
        private notification: NotificationService,
        private dialogRef: MatDialogRef<ParagraphFormComponent>,
        @Inject(MAT_DIALOG_DATA) private dialogData: DialogData,
        private renderer: Renderer2,
        private seriesData: SeriesDataService
    ) {
        this.paragraph = Object.keys(dialogData.config?.paragraph_body)?.length ? dialogData.config.paragraph_body : '';
    }

    ngOnInit() {
        this.seriesData.$estimate_types.promise.then(response => {
            this.allColumns = this.seriesData.fillColumns(response?.map(et => et.attributes.name));
            this.insertColumn = this.allColumns.columns.find(col => col.name === "Value");
        });
        const Size: any = Quill.import('formats/size');
        Size.whitelist = ALLOWED_FONT_SIZES;
        Quill.register(Size, true);
    }

    onEditorCreated(quill) {
        this.quillInstance = quill;
    }

    selectLocalImage() {
        this.fileUpload.nativeElement.value = '';
        this.fileUpload.nativeElement.click();

        this.fileUpload.nativeElement.onchange = () => {
            const file = this.fileUpload.nativeElement.files?.[0];
            if (file) {
                this.uploadImage(file);
            }
        };
    }

    uploadImage(file: File) {
        const formData = new FormData();
        formData.append('file', file, file.name);

        const quill = this.quillInstance;
        const range = quill.getSelection(true);
        console.log("range", range);
        quill.enable(false);
        this.notification.openSuccess('Uploading image...');

        this.http.post('/api/BlobData', formData).subscribe({
            next: (response: any) => {
                const url = `admin/myfiles/download${response.file_name}`;
                quill.enable(true);
                quill.insertEmbed(range.index, 'image', url, 'user');
                quill.setSelection(range.index + 1);
                this.notification.openSuccess('Image uploaded successfully.', NOTIFICATION_DURATION_MS);
            },
            error: (err) => {
                quill.enable(true);
                this.notification.openError('Failed to upload image.');
                console.error(err);
            }
        });
    }

    adjustTooltip(event) {
        let tooltips = document.querySelectorAll('div.ql-tooltip:not(.ql-hidden)');

        if (tooltips && tooltips.length > 0) {
            let parent = tooltips[0].closest(".ql-container.ql-snow");

            let t = tooltips[0].getBoundingClientRect();
            let p = parent.getBoundingClientRect();
            // @ts-ignore
            let left = t.x;
            // @ts-ignore
            if ((left + tooltips[0].offsetWidth) > (p.x + p.width)) {
                let diff = p.width - t.width + 10;
                this.renderer.setStyle(tooltips[0], 'left', `${diff}px`);
            } else if ((left < p.x) || (left < 0)) {
                this.renderer.setStyle(tooltips[0], 'left', "-10px");
            }
        }
    }

    addToFormula(event) {
        if (event) {
            this.insert_series = event.value;
        }
        if (this.insert_series && this.insertColumn) {
            this.gssInsert = [`[${this.insert_series.attributes.name}@${this.insertColumn.name}]`];
            copyStringToClipboard(this.gssInsert, this.notification);
        }
    }

    async copyToClipboard(el: HTMLInputElement) {
        copyStringToClipboard(el.value, this.notification);
    }

    save() {
        this.dialogRef.close({paragraph_body: this.paragraph});
    }

    onCloseClick(): void {
        this.dialogRef.close();
    }
}
